export default {
  from: {
    new: 'Mới',
    'delivery-from': 'Giao từ',
  },
  to: {
    delivered: 'Đã giao đến',
    deliver: 'Giao đến',
  },
  comment: 'Bình luận của tài xế',
}
